import { Stack, Label, FontIcon, IStackTokens } from '@fluentui/react';
import React, { useContext, useEffect, useState } from 'react';
import styles from '../styles/collectie.module.scss';
import {TProduct, TSet, TSize } from '../constants/types';
import Product from './Product/productComponent';
import GlobalContext from '../_contexts/GlobalContext';

export interface IBuyAllComponentProps {
    SetID? : number;
    Buy: Function;
}

const BuyAll : React.FunctionComponent<IBuyAllComponentProps> = (props : IBuyAllComponentProps) => {
    const [price, setprice] = useState<number>(0);
    const [discount, setDiscount] = useState<number>(0);
    const [discountedPrice, setDiscountedPrice] = useState<number>(0);

    const { DevEnabled, BUYCOMPLETECOLLECTIONDISCOUNT, BUYCOMPLETESETDISCOUNT } = useContext(GlobalContext);

    useEffect(() => {
        if (BUYCOMPLETECOLLECTIONDISCOUNT && BUYCOMPLETESETDISCOUNT) {
            let hostUrl = `${window.location.origin}/Backend`
            if (DevEnabled) {
                hostUrl = process.env.REACT_APP_DEV_API_URL;
            }

            let localPrice = 0;
            if (props.SetID) {
                fetch(`${hostUrl}/GetSetPrice?setid=${props.SetID}`, {
                    method: 'GET',
                }).then((response) => response.json()).then((p: number) => {
                    localPrice = p;
                    setprice(p);
                    setDiscount(BUYCOMPLETESETDISCOUNT);
                    const discountPrice = localPrice * (BUYCOMPLETESETDISCOUNT/100);
                    setDiscountedPrice(localPrice-discountPrice);
                }).catch(err => {
                    console.log(err);
                });
            } else {
                fetch(`${hostUrl}/GetCollectionPrice`, {
                    method: 'GET',
                }).then((response) => response.json()).then((p: number) => {
                    localPrice = p;
                    setprice(p);
                    setDiscount(BUYCOMPLETECOLLECTIONDISCOUNT);
                    const discountPrice = localPrice * (BUYCOMPLETECOLLECTIONDISCOUNT/100);
                    setDiscountedPrice(localPrice-discountPrice);
                }).catch(err => {
                    console.log(err);
                });
            }
        }
    },[BUYCOMPLETESETDISCOUNT, BUYCOMPLETECOLLECTIONDISCOUNT]);

    function buy() {
        if (props.SetID) {
            props.Buy(props.SetID, true, Math.round(discountedPrice*100)/100);
        } else {
            props.Buy();
        }
    }

    return (   
        <Stack className={`${styles.buyAllContainer}`}>
            <Stack horizontal horizontalAlign='center' style={{backgroundColor:"#30a7d7", paddingRight: 5}}>
                <a onClick={buy}>
                    <span><FontIcon style={{maxHeight:"90%", verticalAlign:"middle", fontSize:window.innerWidth > 960 ? 25 : 15, backgroundColor:"#30a7d7"}} 
                                                className={styles.buyButton} 
                                                iconName={"ShoppingCart"} />Hele {props.SetID ? "set" : "collectie"} <b>€{Math.round(discountedPrice*100)/100}</b> <s style={{fontSize:"small"}}>€{Math.round(price*100)/100}</s></span>
                </a>
            </Stack>
        </Stack>
    );    
}

export default BuyAll;